import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardTitle,
  CCol,
  CForm,
  CRow,
  CToast,
  CToastBody,
  CToastClose,
  CToaster,
} from "@coreui/react-pro";
import { usePssLogoPicture } from "../controllers";
import { InsigniaImage } from "./components";
import { LoadingOverlay } from "../../../../components";
import { cilCheckCircle } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";

const PssLogoPicture = (): JSX.Element => {
  const [s, c] = usePssLogoPicture();

  // Layout
  return (
    <>
      <LoadingOverlay isOpen={s.apiInsertLoading} />
      <CCard>
        <CCardTitle
          style={{
            borderBottom: "1px solid rgba(0, 0, 0, 0.125)",
            padding: "10px 15px",
            marginBottom: "10px",
          }}
        >
          <CRow className="align-items-center">
            <CCol xs={6}>
              <h5 className="fw-semibold">Logo Picture</h5>
            </CCol>
            {/* <CCol xs={6} className="text-end">
            <CButton color="primary" onClick={userAction.onAddNewUser}>
              <CIcon icon={cilPlus} /> <span>Add User Group</span>
            </CButton>
          </CCol> */}
          </CRow>
        </CCardTitle>
        {/* <CCardTitle>Logo Picture</CCardTitle> */}
        <CCardBody>
          <CForm noValidate onSubmit={c.submitForm}>
            <strong className="text-underline">Descriptions</strong>
            <CCol id="InsigniaUploader" xs={12} md={5}>
              <InsigniaImage
                label="Logo Picture (Optional)"
                helperText="Accept .png, .jpeg and .jpg"
                state={s.insignia}
                controller={c.insignia}
              />
            </CCol>
            <hr />
            <CRow className="justify-content-center">
              <CAlert
                className="w-75  text-center"
                color="danger"
                visible={s.invalidFormMsg !== null}
              >
                {s.invalidFormMsg}
              </CAlert>
              <CAlert
                className="w-75  text-center"
                color="danger"
                visible={s.apiInsertError}
              >
                {s.apiInsertErrorMsg}
              </CAlert>
              <CAlert
                className="w-75  text-center"
                color="success"
                visible={s.apiInsertSuccess}
              ></CAlert>
            </CRow>
            <CCol className="text-end">
              <CButton color="secondary" className="me-2" onClick={c.resetForm}>
                Reset
              </CButton>
              <CButton type="submit">Submit</CButton>
            </CCol>
          </CForm>
        </CCardBody>
        {/* ---- Success Toast ---------*/}
        <CToaster placement="top-end">
          <CToast
            autohide={true}
            visible={s.showSuccessToast}
            color="success"
            className="text-white align-items-center"
          >
            <div className="d-flex justify-contgent-center align-items-center">
              <CIcon
                icon={cilCheckCircle}
                size="xl"
                style={{ marginLeft: "12px " }}
              />
              <CToastBody>Logo added successfully!</CToastBody>
              <CToastClose className="me-2 m-auto" white />
            </div>
          </CToast>
        </CToaster>
      </CCard>
    </>
  );
};

export default PssLogoPicture;
